var ajax = new XMLHttpRequest();
ajax.open('GET', '/img/sprite-sheet.svg', true);
ajax.send();
ajax.onload = function(event) {
  var div = document.createElement('div');
  div.className = 'svg-hidden';
  div.style = 'height: 0; overflow: hidden; position: absolute; width: 0;';
  div.innerHTML = ajax.responseText;
  document.body.insertBefore(div, document.body.childNodes[0]);
}